export enum UserInfoActionsEnum {
  USER_INFO_INIT = 'USER_INFO_INIT',
  USER_INFO_RESET = 'USER_INFO_RESET',
  USER_INFO_GET = 'USER_INFO_GET',
  USER_INFO_SET_KNOS = 'USER_INFO_SET_KNOS',
  USER_INFO_SET_PROSECUTOR = 'USER_INFO_SET_PROSECUTOR',
  USER_INFO_UPDATE_ORGANIZATIONS = 'USER_INFO_UPDATE_ORGANIZATIONS',
  USER_INFO_SET_DEFAULT_FUNCTION = 'USER_INFO_SET_DEFAULT_FUNCTION',
  USER_INFO_GET_KNO_ADMIN_LEVELS = 'USER_INFO_GET_KNO_ADMIN_LEVELS',
  USER_INFO_GET_ORGANISATIONS = 'USER_INFO_GET_ORGANISATIONS',
  USER_INFO_GET_ORGANISATIONS_NEXT_PAGE = 'USER_INFO_GET_ORGANISATIONS_NEXT_PAGE',
  USER_INFO_SET_ORGANISATIONS = 'USER_INFO_SET_ORGANISATIONS',
  USER_INFO_SET_ORGANIZATIONS_SEARCH_QUERY = 'USER_INFO_SET_ORGANIZATIONS_SEARCH_QUERY',
  USER_INFO_SET_ORGANIZATIONS_PARENT_ID = 'USER_INFO_SET_ORGANIZATIONS_PARENT_ID',
  USER_INFO_SET_ORGANIZATIONS_ADMIN_LEVEL_CODE = 'USER_INFO_SET_ORGANIZATIONS_ADMIN_LEVEL_CODE',
  USER_INFO_SET_ORGANIZATIONS_SEARCH_CRITERIA = 'USER_INFO_SET_ORGANIZATIONS_SEARCH_CRITERIA',
  USER_INFO_KNO_ORGANIZATIONS_RESET = 'USER_INFO_KNO_ORGANIZATIONS_RESET',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_GET = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_GET',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_REQUEST = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_REQUEST',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_SUCCESS = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_SUCCESS',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_FAILURE = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_FAILURE',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_REQUEST = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_REQUEST',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_SUCCESS = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_SUCCESS',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_FAILURE = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_FAILURE',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_DISTRICT_ID = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_DISTRICT_ID',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_QUERY = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_QUERY',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_PARENT_ID = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_PARENT_ID',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_OGRN = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_OGRN',
  USER_INFO_PROSECUTOR_ORGANIZATIONS_RESET = 'USER_INFO_PROSECUTOR_ORGANIZATIONS_RESET',
  SET_IS_RECEIVE_USER_ORG = 'SET_IS_RECEIVE_USER_ORG',
  USER_INFO_SET_CURRENT_FUNCTIONS_MODAL_ID = 'USER_INFO_SET_CURRENT_FUNCTIONS_MODAL_ID',
  USER_INFO_SET_IS_ERVK = 'USER_INFO_SET_IS_ERVK',
  USER_INFO_SET_HIGHLIGHTED_SELECTED_ORGANISATIONS = 'USER_INFO_SET_HIGHLIGHTED_SELECTED_ORGANISATIONS',
  USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET = 'USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET',
  USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET_SUCCESS = 'USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET_SUCCESS',
}
